import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "faq-wrap" }
const _hoisted_3 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexFaq',
  setup(__props) {

const faqWidgets = defineAsyncComponent(() => import("@/components/theme/faq/faqWidgets.vue"))
const faqAccordion = defineAsyncComponent(() => import("@/components/theme/faq/faqAccordion.vue"))
const featuredTutorial = defineAsyncComponent(() => import("@/components/theme/faq/featuredTutorial.vue"))
const faqArticles = defineAsyncComponent(() => import("@/components/theme/faq/faqArticles.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "FAQ",
      title: "FAQ"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(faqWidgets)),
          _createVNode(_unref(faqAccordion)),
          _createVNode(_unref(featuredTutorial)),
          _createVNode(_unref(faqArticles))
        ])
      ])
    ])
  ], 64))
}
}

})